import { FC } from 'react'
import {
  Dropdown as BaseDropDown,
  DropDownProps as BaseDropDownProps,
} from 'antd'
import { DropdownButton } from './dropdown-button'

export interface DropdownProps extends FC<BaseDropDownProps> {
  Button: typeof DropdownButton
}

const Dropdown: DropdownProps = (props): JSX.Element => {
  return <BaseDropDown {...props} />
}

Dropdown.Button = DropdownButton

export { Dropdown }
